import React from 'react';
import WorkdayLogo from './WorkdayLogo.png';

const Workday: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width={126}
    height={50}
    viewBox="0 0 126 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <image href={WorkdayLogo} width="126" height="50" preserveAspectRatio="xMidYMid meet" />
  </svg>
);

export default Workday;
